// Legal documents (bilingual). [BRACKETS] are placeholders for the association to complete.
export const ASSO = {
  name: "[NOM DE L'ASSOCIATION]",
  statut: "[STATUT JURIDIQUE]",
  address: "[ADRESSE]",
  email: "fredericmsv@gmail.com",
  siret: "[SIRET / RNA]",
  host: "[HÉBERGEUR]",
  church: "Providence",
  minAge: "18",
  retention: "[DURÉE À DÉFINIR]",
};

const A = ASSO;

export const TERMS = {
  title: { fr: "Conditions Générales d'Utilisation", en: "Terms of Service" },
  updated: { fr: "Version 1.0", en: "Version 1.0" },
  sections: [
    {
      h: { fr: "Éditeur", en: "Publisher" },
      p: {
        fr: `Boussole est éditée par ${A.name} (${A.statut}), ${A.address}. Contact : ${A.email}. ${A.siret}. Hébergeur : ${A.host}.`,
        en: `Boussole is published by ${A.name} (${A.statut}), ${A.address}. Contact: ${A.email}. ${A.siret}. Hosting provider: ${A.host}.`,
      },
    },
    {
      h: { fr: "Objet", en: "Purpose" },
      p: {
        fr: "Boussole aide les nouveaux étudiants internationaux à se repérer et s'installer en France.",
        en: "Boussole helps new international students find their bearings and settle in France.",
      },
    },
    {
      h: { fr: "Compte", en: "Account" },
      p: {
        fr: `L'inscription requiert des informations exactes et à jour. Vous êtes responsable de la confidentialité de vos identifiants. Âge minimum requis : ${A.minAge} ans.`,
        en: `Registration requires accurate, up-to-date information. You are responsible for keeping your credentials confidential. Minimum age: ${A.minAge}.`,
      },
    },
    {
      h: { fr: "Règles d'usage", en: "Rules of use" },
      p: {
        fr: "Respectez les autres utilisateurs. Le harcèlement, les contenus illicites ou haineux sont interdits. Vous pouvez signaler ou bloquer un utilisateur. Tout manquement peut entraîner la suspension du compte.",
        en: "Respect other users. Harassment, illegal or hateful content are prohibited. You may report or block a user. Any breach may lead to account suspension.",
      },
    },
    {
      h: { fr: "Mise en relation entre utilisateurs", en: "Connections between users" },
      p: {
        fr: "Boussole facilite les échanges (Réseau, Buddy, messagerie) mais n'est pas partie aux relations entre utilisateurs et ne garantit pas leur comportement. Faites preuve de prudence lors de vos rencontres.",
        en: "Boussole facilitates exchanges (Network, Buddy, messaging) but is not a party to relationships between users and does not guarantee their behaviour. Please exercise caution when meeting people.",
      },
    },
    {
      h: { fr: "Informations administratives", en: "Administrative information" },
      p: {
        fr: "Les informations administratives sont fournies à titre indicatif et informatif, sont non contractuelles et susceptibles d'évoluer. Elles ne constituent pas un conseil juridique. Vérifiez toujours sur les sites officiels.",
        en: "Administrative information is provided for guidance only, is non-contractual and subject to change. It does not constitute legal advice. Always verify on official websites.",
      },
    },
    {
      h: { fr: "Communauté de foi", en: "Faith community" },
      p: {
        fr: "L'adhésion à la communauté de foi est facultative et repose sur un consentement explicite et réversible à tout moment.",
        en: "Joining the faith community is optional and relies on explicit, reversible consent at any time.",
      },
    },
    {
      h: { fr: "Propriété intellectuelle", en: "Intellectual property" },
      p: {
        fr: `La marque, le contenu et le code de Boussole appartiennent à ${A.name}.`,
        en: `The Boussole brand, content and code belong to ${A.name}.`,
      },
    },
    {
      h: { fr: "Disponibilité", en: "Availability" },
      p: {
        fr: "Le service peut être modifié, suspendu ou interrompu à tout moment ; aucune garantie de disponibilité permanente n'est fournie.",
        en: "The service may be changed, suspended or interrupted at any time; no guarantee of permanent availability is given.",
      },
    },
    {
      h: { fr: "Données personnelles", en: "Personal data" },
      p: {
        fr: "Le traitement de vos données est décrit dans la Politique de confidentialité.",
        en: "The processing of your data is described in the Privacy Policy.",
      },
    },
    {
      h: { fr: "Modification des CGU", en: "Changes to the Terms" },
      p: {
        fr: "Les utilisateurs sont informés en cas de modification des CGU ; une nouvelle acceptation peut être demandée.",
        en: "Users are informed of any change to the Terms; renewed acceptance may be required.",
      },
    },
    {
      h: { fr: "Droit applicable", en: "Governing law" },
      p: {
        fr: `Droit français. Pour toute réclamation : ${A.email}. En cas de litige, une médiation peut être envisagée ; vous pouvez également saisir la CNIL.`,
        en: `French law. For any complaint: ${A.email}. In case of dispute, mediation may be considered; you may also contact the CNIL.`,
      },
    },
  ],
};

export const PRIVACY = {
  title: { fr: "Politique de confidentialité", en: "Privacy Policy" },
  updated: { fr: "Version 1.0", en: "Version 1.0" },
  sections: [
    {
      h: { fr: "Responsable de traitement", en: "Data controller" },
      p: {
        fr: `${A.name}, ${A.address}. Contact : ${A.email}.`,
        en: `${A.name}, ${A.address}. Contact: ${A.email}.`,
      },
    },
    {
      h: { fr: "Données collectées", en: "Data collected" },
      p: {
        fr: "Identité (nom, prénom, email), adresses (résidence, école), date d'arrivée, langues, centres d'intérêt, données d'usage, et — uniquement sur consentement explicite — l'appartenance à la communauté de foi.",
        en: "Identity (last name, first name, email), addresses (home, school), arrival date, languages, interests, usage data, and — only with explicit consent — membership of the faith community.",
      },
    },
    {
      h: { fr: "Finalités", en: "Purposes" },
      p: {
        fr: "Faire fonctionner l'application (repères, budget, démarches, réseau/buddy) et, sur consentement, la mise en relation avec la communauté.",
        en: "To operate the app (landmarks, budget, procedures, network/buddy) and, with consent, connection with the community.",
      },
    },
    {
      h: { fr: "Base légale", en: "Legal basis" },
      p: {
        fr: "Exécution du service ; consentement pour les données sensibles (appartenance religieuse).",
        en: "Performance of the service; consent for sensitive data (religious affiliation).",
      },
    },
    {
      h: { fr: "Destinataires", en: "Recipients" },
      p: {
        fr: `L'association ${A.name}. Pour la communauté de foi, ${A.church} uniquement après votre consentement.`,
        en: `The association ${A.name}. For the faith community, ${A.church} only after your consent.`,
      },
    },
    {
      h: { fr: "Durée de conservation", en: "Retention period" },
      p: { fr: A.retention, en: A.retention },
    },
    {
      h: { fr: "Vos droits (RGPD)", en: "Your rights (GDPR)" },
      p: {
        fr: `Accès, rectification, effacement, retrait du consentement, portabilité, opposition. Contact : ${A.email}. Vous pouvez aussi introduire une réclamation auprès de la CNIL.`,
        en: `Access, rectification, erasure, withdrawal of consent, portability, objection. Contact: ${A.email}. You may also lodge a complaint with the CNIL.`,
      },
    },
    {
      h: { fr: "Sécurité et hébergement", en: "Security and hosting" },
      p: {
        fr: `Hébergement : ${A.host}. Des mesures de sécurité techniques et organisationnelles protègent vos données.`,
        en: `Hosting: ${A.host}. Technical and organisational security measures protect your data.`,
      },
    },
  ],
};
